import Vue from '../main'

export default {
  getCapitulos({before}) {
    const params = {};
    params['filters'] = ['capitulo:all', 'vigentes:true'];
    params['orderBy'] = 'codigo';
    return Vue.$http.get(`${process.env.VUE_APP_ROOT_API}partidasarancelarias`, {params, before});
  },
  getChildren(codigo) {
    const params = {};
    params['filters'] = [`children:${codigo}`, 'vigentes:true'];
    params['orderBy'] = 'codigo';
    return Vue.$http.get(`${process.env.VUE_APP_ROOT_API}partidasarancelarias`, {params});
  },
  search(search, {before}) {
    const params = {filter: search};
    params['filters'] = ['vigentes:true'];
    return Vue.$http.get(`${process.env.VUE_APP_ROOT_API}partidasarancelarias`, {params, before});
  },
}
